<template>
  <div style="padding: 20px; position: relative">
    <div style="position: relative">
      <div>
        <strong class="strong-title">{{ $t('keyword.report_analysis') }}</strong>
      </div>

      <div style="margin-top: 20px">
        <div style="display: flex;">
          <el-date-picker
            style="width: 300px; max-width: 300px; margin-right: 10px"
            v-model="date_range" class="full-w" type="daterange" range-separator="-"
            :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')" size="mini"
            format="dd-MM-yyyy"
            :clearable="false" :picker-options="picker_options">
          </el-date-picker>
          <el-button type="primary" size="mini" icon="el-icon-search" :loading="loading.get_data"
                     @click="m__report_analysis()"> {{ $t('base.analyze') }}
          </el-button>
          <el-button type="primary" size="mini" icon="el-icon-upload" :loading="loading.get_data"
                     @click="m__on_select_csv_file()"> {{ $t('base.upload_report') }}
          </el-button>
        </div>
      </div>

      <div style="margin-top: 50px">
        <div style="display: flex">
          <div style="width: 250px">
            <el-input size="mini" :placeholder="$t('input.placeholder')" suffix-icon="el-icon-search" clearable
                      v-model="keyword_filter.search_keyword" style="opacity: 1"></el-input>
          </div>
          <div style="flex: 1; text-align: right">
            <el-button type="primary" size="mini" icon="el-icon-plus" @click="m__show_add_keywords_dialog()">
              {{ $t('keyword.add_to_campaigns') }}
            </el-button>
            <el-button size="mini" type="info" icon="ti-save" @click="m__initial_save_keyword_file(true)">
              {{ $t('keyword.save_file') }}
            </el-button>
            <el-button size="mini" @click="m__show_filter_dialog">
              <i class="ti-panel"></i>&nbsp; {{ $t('base.filter') }}
              <strong style="font-weight: 700" v-if="mix_filter.some(i => i.value)" class="text-success">[ ON ]</strong>
              <strong style="font-weight: 700" v-else class="text-danger">[ OFF ]</strong>
            </el-button>
            <el-button size="mini" @click="m__toggle_select_index">
              <i :class="show_dialog.select_index ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
              {{ $t('ads.select_metrics') }}
            </el-button>
          </div>
        </div>
        <div v-if="show_dialog.select_index"
             style="border: 1px solid #e5e5e5;border-radius: 4px; padding: 20px 10px 10px 10px; margin-top: 10px">
          <div style="width: 20%; float: left; margin-bottom: 10px; font-size: 13px" v-for="flag in flag_list"
               :key="flag.label">
            <el-checkbox size="mini" v-model="flag.checked" @change="m__update_flag_list" class="cbx-black"
                         :disabled="flag.checked === true && flag_list.filter(i => i.checked === true).length <= 1">
              &nbsp;{{ flag.label }}
            </el-checkbox>
          </div>
          <div style="clear: both!important;"></div>

          <br>

          <div v-for="flag in atosa_flag_list" :key="flag.value"
               style="width: 20%; float: left; margin-bottom: 10px; font-size: 13px">
            <el-checkbox size="mini" v-model="flag.checked" @change="m__set_atosa_flag_list" class="cbx-black">
              &nbsp;{{ flag.label }}
            </el-checkbox>
          </div>
          <div style="clear: both!important;"></div>
        </div>

        <div style="margin-top: 20px">
          <div style="height: 30px">
            <a
              v-if="is_selected_all && c__show_keyword_display_list.filter(i => !i.auto && !i.is_summary).length < c__show_keyword_filter_list.length"
              href="javascript:void(0)" style="font-weight: 700; font-size: 13px"
              class="text-primary" @click="m__checked_by_page">
              {{ $t('base.select') }} {{ c__show_keyword_display_list.filter(i => !i.auto && !i.is_summary).length }}
              {{ $t('base.x_on_current_page', {x: $t('base.keyword')}) }}
            </a>
          </div>
          <el-table id="main-table-detail" :data="c__show_keyword_display_list"
                    @sort-change="m__sort_change" :row-style="m__style_for_summary" v-loading="loading.get_data">
            <el-table-column width="40px" fixed="left">
              <template slot="header" slot-scope="scope">
                <el-checkbox v-if="c__show_keyword_filter_list.length"
                             size="mini" :indeterminate="indeterminate" v-model="is_selected_all"
                             @change="m__select_all"></el-checkbox>
              </template>
              <template slot-scope="scope">
                <el-checkbox v-if="!scope.row.auto && !scope.row.is_summary" size="mini" v-model="scope.row.checked"
                             @change="m__indeterminate($event)"
                             @click.native="m__on_checkbox_click($event, scope.$index)"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.keyword')" width="210px" show-tooltip-when-overflow fixed="left">
              <template slot="header" slot-scope="scope">
                <div>
                  {{ $t('base.keyword') }}
                </div>
                <!--                <div style="margin-top: 5px; height: 35px; padding-right: 15px">-->
                <!--                  <el-input v-model="keyword_filter.search_keyword_a" size="mini" clearable-->
                <!--                            prefix-icon="el-icon-search"></el-input>-->
                <!--                </div>-->
              </template>
              <template slot-scope="scope">
                <div v-if="scope.row.is_summary" style="padding: 3px 0">
                  <el-input v-model="keyword_filter.search_keyword_a" size="mini" clearable
                            prefix-icon="el-icon-search"></el-input>
                </div>
                <div v-else
                     v-on:dblclick="open_link_fixed(`https://shopee.vn/search?keyword=${scope.row.keyword.normalize()}`, shop)"
                     class="atosa-keyword" style="font-size: 13px">{{ scope.row.keyword.normalize() }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.search_query')" width="210px" show-tooltip-when-overflow fixed="left">
              <template slot="header" slot-scope="scope">
                <div>
                  <el-dropdown trigger="click">
                    <strong class="el-dropdown-link" :class="{'text-primary': search_keyword_type !== ''}">
                      {{ $t('base.search_query') }}
                    </strong>
                    <i class="el-icon-arrow-down"></i>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="search_keyword_type = ''">
                        <div style="display: flex; gap: 10px">
                          <div style="flex: auto">{{ $t('keyword.all') }}</div>
                          <div style="width: 10px">
                            <i v-if="search_keyword_type === ''" class="el-icon-check"></i>
                          </div>
                        </div>
                      </el-dropdown-item>
                      <el-dropdown-item @click.native="search_keyword_type = 'match'">
                        <div style="display: flex; gap: 10px">
                          <div style="flex: auto">{{ $t('keyword.match_to_original_keyword') }}</div>
                          <div style="width: 10px">
                            <i v-if="search_keyword_type === 'match'" class="el-icon-check"></i>
                          </div>
                        </div>
                      </el-dropdown-item>
                      <el-dropdown-item @click.native="search_keyword_type = 'not_match'">
                        <div style="display: flex; gap: 10px">
                          <div style="flex: auto">{{ $t('keyword.not_match_to_original_keyword') }}</div>
                          <div style="width: 10px">
                            <i v-if="search_keyword_type === 'not_match'" class="el-icon-check"></i>
                          </div>
                        </div>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <!--                <div style="margin-top: 5px; height: 35px; padding-right: 15px">-->
                <!--                  <el-input v-model="keyword_filter.search_keyword_b" size="mini" clearable-->
                <!--                            prefix-icon="el-icon-search"></el-input>-->
                <!--                </div>-->
              </template>
              <template slot-scope="scope">
                <div v-if="scope.row.is_summary" style="padding: 3px 0">
                  <el-input v-model="keyword_filter.search_keyword_b" size="mini" clearable
                            prefix-icon="el-icon-search"></el-input>
                </div>
                <div v-else
                     v-on:dblclick="open_link_fixed(`https://shopee.vn/search?keyword=${scope.row.search_keyword.normalize()}`, shop)"
                     class="atosa-keyword" style="font-size: 13px">{{ scope.row.search_keyword.normalize() }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.status')" width="130px" show-overflow-tooltip>
              <template slot="header" slot-scope="scope">
                <el-dropdown trigger="click">
                  <strong class="el-dropdown-link" :class="{'text-primary': is_exists_type !== ''}">
                    {{ $t('base.status') }}
                  </strong>
                  <i class="el-icon-arrow-down"></i>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="is_exists_type = ''">
                      <div style="display: flex; gap: 10px">
                        <div style="flex: auto">{{ $t('keyword.all') }}</div>
                        <div style="width: 10px">
                          <i v-if="is_exists_type === ''" class="el-icon-check"></i>
                        </div>
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="is_exists_type = 'exists'">
                      <div style="display: flex; gap: 10px">
                        <div style="flex: auto">{{ $t('keyword.existing_in_campaign') }}</div>
                        <div style="width: 10px">
                          <i v-if="is_exists_type === 'exists'" class="el-icon-check"></i>
                        </div>
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="is_exists_type = 'not_exists'">
                      <div style="display: flex; gap: 10px">
                        <div style="flex: auto">{{ $t('keyword.not_existing_in_campaign') }}</div>
                        <div style="width: 10px">
                          <i v-if="is_exists_type === 'not_exists'" class="el-icon-check"></i>
                        </div>
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
              <template slot-scope="scope">
                <div v-if="scope.row.is_summary">-</div>
                <div v-else>
                  <el-tag v-if="scope.row.is_exists" size="mini" type="success">{{ $t('keyword.existed') }}</el-tag>
                  <el-tag v-if="!scope.row.is_exists" size="mini" type="danger">{{ $t('keyword.not_existed') }}</el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('keyword.type')" width="120px" show-overflow-tooltip>
              <template slot="header" slot-scope="scope">
                <el-dropdown trigger="click">
                  <strong class="el-dropdown-link" :class="{'text-primary': is_match_type !== ''}">
                    {{ $t('keyword.type') }}
                  </strong>
                  <i class="el-icon-arrow-down"></i>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="is_match_type = ''">
                      <div style="display: flex; gap: 10px">
                        <div style="flex: auto">{{ $t('keyword.all') }}</div>
                        <div style="width: 10px">
                          <i v-if="is_match_type === ''" class="el-icon-check"></i>
                        </div>
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="is_match_type = '0'">
                      <div style="display: flex; gap: 10px">
                        <div style="flex: auto">{{ $t('keyword.exact') }}</div>
                        <div style="width: 10px">
                          <i v-if="is_match_type === '0'" class="el-icon-check"></i>
                        </div>
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="is_match_type = '1'">
                      <div style="display: flex; gap: 10px">
                        <div style="flex: auto">{{ $t('keyword.broad') }}</div>
                        <div style="width: 10px">
                          <i v-if="is_match_type === '1'" class="el-icon-check"></i>
                        </div>
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
              <template slot-scope="scope">
                <div v-if="scope.row.is_summary">-</div>
                <div v-else>
                  <template v-if="scope.row.match_type === 0">{{ $t('base.exact') }}</template>
                  <template v-if="scope.row.match_type === 1">{{ $t('base.broad') }}</template>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.volume')" width="140px" prop="shopee_volume"
                             sortable="custom">
              <template slot-scope="scope">
                <template v-if="scope.row.auto">-</template>
                <template v-else-if="scope.row.is_summary">-</template>
                <template v-else>
                  {{ scope.row.shopee_volume | currency }}
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.search_query_volume')" width="140px" prop="shopee_volume_search_keyword"
                             sortable="custom">
              <template slot-scope="scope">
                <template v-if="scope.row.auto">-</template>
                <template v-else-if="scope.row.is_summary">-</template>
                <template v-else>
                  {{ scope.row.shopee_volume_search_keyword | currency }}
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.average_ranking')" width="120px" prop="average"
                             v-if="m__is_show_index('avg_rank')" sortable="custom">
              <template slot-scope="scope">
                <template v-if="scope.row.auto">-</template>
                <template v-else-if="scope.row.is_summary">-</template>
                <template v-else>
                  {{ scope.row ? scope.row.avg_rank : 0 | currency }}

                  <div v-if="is_compare_keyword" class="compare-keyword">
                    {{ scope.row.c_report ? scope.row.c_avg_rank : 0 | currency }}
                  </div>
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.impressions')" width="120px" prop="impression"
                             v-if="m__is_show_index('impression')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? scope.row.impression : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? scope.row.c_impression : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.clicks')" width="120px" prop="click"
                             v-if="m__is_show_index('click')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? scope.row.click : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? scope.row.c_click : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="CPC" width="120px" prop="atosa_cpc"
                             v-if="m__is_show_index('click')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? scope.row.atosa_cpc : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? scope.row.c_atosa_cpc : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.ctr')" width="100px" prop="ctr"
                             v-if="m__is_show_index('ctr')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? (parseFloat(scope.row.ctr) * 100).toFixed(1) : '0.0' }} %

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? (parseFloat(scope.row.c_ctr) * 100).toFixed(1) : '0.0' }} %
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.conversions')" width="140px" prop="broad_order"
                             v-if="m__is_show_index('broad_order')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? scope.row.broad_order : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? scope.row.c_broad_order : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.direct_conversions')" width="115px" prop="direct_order"
                             v-if="m__is_show_index('broad_order')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? scope.row.direct_order : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? scope.row.c_direct_order : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.items_sold')" width="150px" prop="broad_order_amount"
                             v-if="m__is_show_index('broad_order_amount')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? scope.row.broad_order_amount : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? scope.row.c_broad_order_amount : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.direct_items_sold')" width="125px" prop="direct_order_amount"
                             v-if="m__is_show_index('direct_order_amount')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? scope.row.direct_order_amount : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? scope.row.c_direct_order_amount : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="GMV" width="120px" prop="broad_gmv"
                             v-if="m__is_show_index('broad_gmv')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? m__calculate(scope.row.broad_gmv) : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? m__calculate(scope.row.c_broad_gmv) : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.direct_gmv')" width="130px" prop="direct_gmv"
                             v-if="m__is_show_index('direct_gmv')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? m__calculate(scope.row.direct_gmv) : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? m__calculate(scope.row.c_direct_gmv) : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.expense')" width="120px" prop="cost"
                             v-if="m__is_show_index('cost')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? m__calculate(scope.row.cost) : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? m__calculate(scope.row.c_cost) : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="ROI (ROAS)" width="120px" prop="broad_roi"
                             v-if="m__is_show_index('broad_roi')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? parseFloat(scope.row.broad_roi).toFixed(2) : 0 }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? parseFloat(scope.row.c_broad_roi).toFixed(2) : 0 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.direct_roi')" width="120px" prop="direct_roi"
                             v-if="m__is_show_index('direct_roi')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? parseFloat(scope.row.direct_roi).toFixed(2) : 0 }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? parseFloat(scope.row.c_direct_roi).toFixed(2) : 0 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="CIR (ACOS)" width="120px" prop="broad_cir"
                             v-if="m__is_show_index('broad_cir')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? (parseFloat(scope.row.broad_cir) * 100).toFixed(1) : 0 }} %

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? (parseFloat(scope.row.c_broad_cir) * 100).toFixed(1) : 0 }} %
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.direct_cir')" width="120px" prop="direct_cir"
                             v-if="m__is_show_index('direct_cir')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? (parseFloat(scope.row.direct_cir) * 100).toFixed(1) : 0 }} %

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? (parseFloat(scope.row.c_direct_cir) * 100).toFixed(1) : 0 }} %
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.conversion_rate')" width="140px" prop="cr"
                             v-if="m__is_show_index('cr')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? (parseFloat(scope.row.cr) * 100).toFixed(1) : 0 }} %

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? (parseFloat(scope.row.c_cr) * 100).toFixed(1) : 0 }} %
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.direct_conversion_rate')" width="140px" prop="direct_cr"
                             v-if="m__is_show_index('direct_cr')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? (parseFloat(scope.row.direct_cr) * 100).toFixed(1) : 0 }} %

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? (parseFloat(scope.row.c_direct_cr) * 100).toFixed(1) : 0 }} %
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.cost_per_conversion')" width="150px" prop="cpc"
                             v-if="m__is_show_index('cpc')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? m__calculate(scope.row.cpc) : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? m__calculate(scope.row.c_cpc) : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.cost_per_direct_conversion')" width="140px" prop="cpdc"
                             v-if="m__is_show_index('cpdc')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? m__calculate(scope.row.cpdc) : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? m__calculate(scope.row.c_cpdc) : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="AOV" width="120px" prop="aov"
                             v-if="m__is_show_atosa_index('aov')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? m__calculate(scope.row.aov) : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? m__calculate(scope.row.c_aov) : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="CPM" width="120px" prop="cpm"
                             v-if="m__is_show_atosa_index('cpm')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row ? m__calculate(scope.row.cpm) : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? m__calculate(scope.row.c_cpm) : 0 | currency }}
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination id="detail-main-pagination"
                         :current-page.sync="keyword_filter.current_page" :page-size="keyword_filter.page_size"
                         layout="prev, pager, next, total" :total="c__show_keyword_filter_list.length"/>
        </div>
      </div>

      <div style="position: absolute; width: 30px; height: 30px; top: 5px; right: 5px; cursor: pointer"
           @click="$emit('update:parent_show_dialog', false)">
        <i class="el-icon-close" style="font-size: 20px"></i>
      </div>
    </div>

    <el-dialog :visible.sync="show_dialog.filter" :close-on-click-modal="false" width="600px">
      <div slot="title" style="padding:10px">
        <form @submit.prevent="m__start_filter">
          <div style="height: calc(100vh - 150px); overflow: auto" @keyup.enter.navtive="m__start_filter" tabindex="0">
            <el-table :data="c__filter_show_list">
              <el-table-column :label="$t('base.column')" prop="label">
                <template slot-scope="scope">
                <span style="font-weight: 700" :class="scope.row.value ? 'text-success' : ''">{{
                    scope.row.label
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="" prop="value2" width="110px">
                <template slot-scope="scope">
                  <el-input v-if="scope.row.expression === '< <'" size="mini" v-model="scope.row.value2"
                            type="number"></el-input>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.expression')" prop="expression" width="110px">
                <template slot-scope="scope">
                  <el-select class="full-w" size="mini" v-model="scope.row.expression">
                    <el-option label=">" value=">"></el-option>
                    <el-option label="<" value="<"></el-option>
                    <el-option label="=" value="==="></el-option>
                    <el-option label="≠" value="!=">
                      <span style="font-size: 16px !important;">≠</span>
                    </el-option>
                    <el-option label="> =" value=">="></el-option>
                    <el-option label="< =" value="<="></el-option>
                    <el-option label="< x <" value="< <"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.value')" prop="value" width="110px">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.value" type="number"></el-input>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.optional')" width="100px" align="right">
                <template slot-scope="scope">
                  <div style="height: 3px"></div>
                  <el-button size="mini" type="danger"
                             @click="() => {scope.row.value = null; scope.row.expression = '>'}">Reset
                  </el-button>
                  <div style="height: 3px"></div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <br><br>
          <el-row>
            <el-col :sm="12" style="padding-left: 10px">
              <el-checkbox v-model="filter_flag">{{ $t('base.display_by_selected_metrics') }}</el-checkbox>
            </el-col>
          </el-row>
          <br>
          <el-row>
            <el-col :sm="24" class="text-right">
              <el-button size="mini" type="default" @click="show_dialog.filter_list = true">
                {{ $t('base.use_saved_filter') }}
              </el-button>
              <el-button size="mini" type="danger" icon="el-icon-delete" @click="m__delete_filter">
                {{ $t('base.delete_filter') }}
              </el-button>
              <el-button size="mini" type="primary" icon="el-icon-check" @submit.prevent="m__start_filter"
                         native-type="submit"> {{ $t('base.execute') }}
              </el-button>
            </el-col>
          </el-row>
        </form>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.filter_list" :close-on-click-modal="false" width="500px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.saved_filter_list') }}</strong>

        <div style="margin-top: 30px">
          <el-table :data="filter_list">
            <el-table-column label="Tên" prop="name"></el-table-column>
            <el-table-column :label="$t('base.optional')" width="150px">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="m__use_filter(scope.row)">
                  <strong class="text-primary">{{ $t('base.use') }}</strong>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.add_keywords" :close-on-click-modal="false" width="750px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('keyword.add_to_campaigns') }}</strong>

        <div style="margin-top: 0">
          <div style="display: flex; justify-content: right; gap: 15px">
            <el-select size="mini" value="" style="width: 200px" v-model="keyword_match_type"
                       @change="add_keyword_list.forEach(i => i.match_type = keyword_match_type)">
              <el-option :value="0" :label="$t('keyword.exact')"></el-option>
              <el-option :value="1" :label="$t('keyword.broad')"></el-option>
            </el-select>
            <el-button size="mini" @click="show_dialog.update_keyword_price = true; keyword_match_type = 0">
              {{ $t('base.edit_bid_price') }}
            </el-button>
          </div>

          <el-table :data="add_keyword_list" style="margin-top: 20px">
            <el-table-column :label="$t('base.keyword')" width="250px" show-tooltip-when-overflow>
              <template slot-scope="scope">
                {{ scope.row.keyword }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('keyword.type')" width="150px">
              <template slot-scope="scope">
                <el-select v-model="scope.row.match_type" size="mini" value="" class="full-w">
                  <el-option :value="0" :label="$t('base.exact')"></el-option>
                  <el-option :value="1" :label="$t('base.broad')"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.bid_price')" width="150px">
              <template slot-scope="scope">
                <el-input v-model="scope.row.price" size="mini" type="number"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.action')" width="150px" align="right">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="m__delete_add_keyword(scope.$index)">
                  <strong class="text-danger">{{ $t('base.delete') }}</strong>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="margin-top: 30px; text-align: right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.add_keywords"
                     @click="m__confirm_add_keywords()">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_keyword_price" :close-on-click-modal="false"
               width="800px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title"> {{ $t('base.mass_edit_x', {x: $t('base.bid_price')}) }} </strong>

        <el-row>
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="1">
              {{ $t('base.i_or_d_x_by_amount', {x: $t('base.bid_price')}) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                <el-select size="mini" v-model="form_update_multiple_keyword_price.update_by_cost" class="full-w"
                           :disabled="form_update_multiple_keyword_price.update_type !== 1">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 1"
                          v-model="form_update_multiple_keyword_price.update_by_cost_value"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="2">
              {{ $t('base.i_or_d_x_by_percent', {x: $t('base.bid_price')}) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                <el-select size="mini" v-model="form_update_multiple_keyword_price.update_by_percent" class="full-w"
                           :disabled="form_update_multiple_keyword_price.update_type !== 2">
                  <el-option value="increase" :label="$t('base.increase')"></el-option>
                  <el-option value="reduce" :label="$t('base.decrease')"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 2"
                          v-model="form_update_multiple_keyword_price.update_by_percent_value"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row style="margin-top: 10px">
          <el-col :sm="12">
            <el-radio v-model="form_update_multiple_keyword_price.update_type" :label="3">
              {{ $t('base.set_x', {x: $t('base.bid_price')}) }}
            </el-radio>
          </el-col>
          <el-col :sm="12">
            <el-row>
              <el-col :sm="12">
                &nbsp;
              </el-col>
              <el-col :sm="12">
                <el-input size="mini" type="number" :disabled="form_update_multiple_keyword_price.update_type !== 3"
                          v-model="form_update_multiple_keyword_price.price"></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <div style="margin-top: 10px" class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__update_keyword_price">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="save_keyword_file.show" :close-on-click-modal="false" custom-class="no-body"
               width="420px">
      <div slot="title" style="padding:10px">
        <div style="">
          <el-radio label="add" v-model="save_keyword_file_type">
            <strong>{{ $t('keyword.save_file') }}</strong>
          </el-radio>
          <div v-if="save_keyword_file_type === 'add'">
            <p class="text-title">{{ $t('base.filename') }}</p>
            <div>
              <el-input size="mini" :placeholder="$t('input.filename')"
                        v-model="save_keyword_file.filename"></el-input>
            </div>
            <div style="padding-top:20px;" class="text-right">
              <el-button size="mini" icon="ti-save" :loading="save_keyword_file.loading" type="primary"
                         @click="m__try_save_keyword_file"> &nbsp; {{ $t('base.save_file') }}
              </el-button>
            </div>
          </div>

          <div style="margin-top: 30px">
            <el-radio label="update" v-model="save_keyword_file_type">
              <strong>{{ $t('keyword.update_existed_file') }}</strong>
            </el-radio>
            <div v-if="save_keyword_file_type === 'update'">
              <p class="text-title">{{ $t('select.keyword_file') }}</p>
              <div>
                <el-select size="mini" value="" v-model="selected_keyword_file" class="full-w" filterable
                           :placeholder="$t('select.keyword_file')">
                  <el-option v-for="keyword in keyword_file_list" :key="keyword._id" :value="keyword._id"
                             :label="keyword.filename"></el-option>
                </el-select>
              </div>
              <div style="padding-top:20px;" class="text-right">
                <el-button size="mini" icon="ti-save" :loading="save_keyword_file.loading" type="primary"
                           @click="m__try_save_keyword_file"> &nbsp; {{ $t('base.update') }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <input id="report_analysis_input" type="file" accept=".csv" @change="m__report_analysis_from_file"
           style="display: none"/>
  </div>
</template>

<script>
import {drop as _drop, orderBy as _orderBy, take as _take, uniqBy as _uniqBy, chunk as _chunk} from "lodash";
import {default_report, picker_options} from "../../../addon/options";
import {ADS_CONSTANTS} from "../../../addon/ads_function";
import {fix_ads_mixins} from "../../../mixins/fix_ads";

export default {
  name: 'component__report_analysis_optimized',

  props: {
    sp_user: null,
    shop: null,
    campaign_id: null,
    parent_start_date: null,
    parent_end_date: null,
    parent_flag_list: null,
    parent_atosa_flag_list: null,
    parent_filter: null,
    parent_keyword_list: null,
    filter: null,
    filter_list: null,
    has_showed_report_analysis: false,
    report_type: null,
    parent_show_dialog: null,
    keyword_file_list: null,
    campaign_type: null,
    match_type_0_min: null,
    match_type_1_min: null,
    ads_config: null
  },

  mixins: [fix_ads_mixins],

  data() {
    return {
      picker_options: picker_options,
      date_range: [new Date(), new Date()],
      keyword_list: [],
      loading: {
        get_data: false,
        add_keywords: false
      },
      keyword_filter: {
        pages: [10, 20, 30, 40, 50, 100],
        page_size: 30,
        current_page: 0,
        total_record: 0,
        selected_type: 'running',
        search_keyword: '',
        search_keyword_a: '',
        search_keyword_b: ''
      },
      indeterminate: false,
      is_selected_all: false,
      is_compare_keyword: false,
      show_dialog: {
        select_index: false,
        filter: false,
        add_keywords: false,
        update_keyword_price: false
      },
      flag_list: [],
      atosa_flag_list: [],
      sort_option: {
        order: null,
        prop: null
      },
      save_and_result_list: [],

      is_match_type: '',
      is_exists_type: '',
      search_keyword_type: '',

      filter_flag: true,
      filter_clone: null,

      add_keyword_list: [],

      form_update_multiple_keyword_price: {
        update_type: 3,
        update_by_cost: 'increase',
        update_by_percent: 'increase',
        update_by_suggest_cost: 'increase',
        update_by_suggest_percent: 'increase',
        update_by_cost_value: 0,
        update_by_percent_value: 0,
        update_by_suggest_cost_value: 1,
        update_by_suggest_percent_value: 1,
        cost_value: 0,
        match_type: 1,
        price: 0
      },

      save_keyword_file: {
        show: false,
        loading: false,
        filename: 'file'
      },
      save_keyword_file_type: 'add',
      save_keyword_type: 'selected',
      selected_keyword_file: '',
      keyword_match_type: 0,
      mix_filter: [],

      last_single_checked: null,

      default_report: {
        ...default_report,
        shopee_volume_search_keyword: 0
      }
    }
  },

  beforeMount() {
    // if (!this.has_showed_report_analysis && !this.keyword_list.length) {
    //   this.m__report_analysis()
    //   this.$emit('update:has_showed_report_analysis', true)
    // }

    this.flag_list = this.clone(this.parent_flag_list)
    this.atosa_flag_list = this.clone(this.parent_atosa_flag_list)

    if (this.filter) {
      this.mix_filter = this.clone(this.filter)
      const index_found = this.mix_filter.findIndex(i => i.camel_key === 'shopee_volume')
      if (index_found !== -1) {
        const new_item = this.clone(this.mix_filter[index_found])
        new_item.camel_key = 'shopee_volume_search_keyword'
        new_item.label = this.$t('base.search_query_volume')
        this.mix_filter.splice(index_found + 1, 0, new_item);
      }
    }
  },

  watch: {
    'parent_keyword_list': function () {
      for (const keyword of this.keyword_list) {
        // keyword.is_exists = this.parent_keyword_list.some(i => i.keyword.normalize() === keyword.search_keyword.normalize())
        keyword.is_exists = this.parent_keyword_list.filter(i => i.status === 1).some(i => i.keyword.normalize() === keyword.search_keyword.normalize())
      }
    }
  },

  computed: {
    c__show_keyword_filter_list() {
      let result = this.keyword_list

      if (this.search_keyword_type === 'match') {
        result = result.filter(i => i.keyword.normalize() === i.search_keyword.normalize())
      }
      if (this.search_keyword_type === 'not_match') {
        result = result.filter(i => i.keyword.normalize() !== i.search_keyword.normalize())
      }

      if (this.is_exists_type === 'exists') {
        result = result.filter(i => i.is_exists)
      }
      if (this.is_exists_type === 'not_exists') {
        result = result.filter(i => !i.is_exists)
      }

      if (this.is_match_type === '0') {
        result = result.filter(i => i.match_type === 0)
      }
      if (this.is_match_type === '1') {
        result = result.filter(i => i.match_type === 1)
      }

      if (this.filter_clone) {
        for (const item of this.filter_clone) {
          if (item.value || (item.expression === '< <' && item.value && item.value2)) {
            result = result.filter(i => {
              const value = item.is_percent === true
                ? i[item.camel_key] * 100
                : i[item.camel_key]

              return item.expression === '< <'
                ? i && eval(`${item.value2} < ${value} && ${value} < ${item.value}`)
                : i && eval(`${value}${item.expression}${item.value}`)
            })
          }
        }
      }

      if (this.sort_option.order) {
        this.sort_option.order === 'ascending' && (result = _orderBy(result, [this.sort_option.prop], ['asc']))
        this.sort_option.order === 'descending' && (result = _orderBy(result, [this.sort_option.prop], ['desc']))
      }

      // const words_a = this.remove_unicode(this.keyword_filter.search_keyword_a)
      // if (words_a) {
      //   result = result.filter(item => this.remove_unicode(item.keyword.normalize()).includes(words_a))
      // }
      //
      // const words_b = this.remove_unicode(this.keyword_filter.search_keyword_b)
      // if (words_b) {
      //   result = result.filter(item => this.remove_unicode(item.search_keyword.normalize()).includes(words_b))
      // }

      if (this.keyword_filter.search_keyword_a) {
        result = result.filter(item => item.keyword.normalize() === this.keyword_filter.search_keyword_a.normalize())
      }
      if (this.keyword_filter.search_keyword_b) {
        result = result.filter(item => item.search_keyword.normalize() === this.keyword_filter.search_keyword_b.normalize())
      }

      const words = this.remove_unicode(this.keyword_filter.search_keyword)
      return result.filter(item => this.remove_unicode(item.keyword.normalize()).includes(words) || this.remove_unicode(item.search_keyword.normalize()).includes(words))
    },

    c__show_keyword_display_list() {
      const summary = {
        keyword: '',
        search_keyword: '',
        is_summary: true,
      }

      for (const keyword of this.c__show_keyword_filter_list) {
        for (const key of Object.keys(this.default_report)) {
          if (!summary[key]) summary[key] = 0
          summary[key] += +keyword[key] || 0
        }
      }

      summary.avg_rank = this.c__show_keyword_filter_list.reduce((acc, i) => acc + i.avg_rank, 0) / this.c__show_keyword_filter_list.length
      this.m__update_summary(summary)

      const limit = this.keyword_filter.page_size
      const skip = limit * (this.keyword_filter.current_page - 1)
      return [summary, ..._take(_drop(this.c__show_keyword_filter_list, skip), limit)]

      // if (this.c__show_keyword_filter_list.length) {
      //   const summary = {
      //     keyword: '',
      //     search_keyword: '',
      //     is_summary: true,
      //   }
      //
      //   for (const keyword of this.c__show_keyword_filter_list) {
      //     for (const key of Object.keys(this.default_report)) {
      //       if (!summary[key]) summary[key] = 0
      //       summary[key] += +keyword[key] || 0
      //     }
      //   }
      //
      //   summary.avg_rank = this.c__show_keyword_filter_list.reduce((acc, i) => acc + i.avg_rank, 0) / this.c__show_keyword_filter_list.length
      //   this.m__update_summary(summary)
      //
      //   const limit = this.keyword_filter.page_size
      //   const skip = limit * (this.keyword_filter.current_page - 1)
      //   return [summary, ..._take(_drop(this.c__show_keyword_filter_list, skip), limit)]
      // } else {
      //   const limit = this.keyword_filter.page_size
      //   const skip = limit * (this.keyword_filter.current_page - 1)
      //   return _take(_drop(this.c__show_keyword_filter_list, skip), limit)
      // }
    },

    c__filter_show_list() {
      if (this.filter_flag) {
        const result = []

        for (const item of this.mix_filter) {
          const flag_found = this.flag_list.find(i => i.value === item.camel_key)
          if (flag_found && flag_found.checked) {
            result.push(item)
          }
        }

        return result
      } else {
        return this.mix_filter
      }
    },
  },

  methods: {
    async m__try_save_keyword_file() {
      const keyword_list = this.c__show_keyword_filter_list.filter(i => i.checked)

      if (this.save_keyword_file_type === 'add') {
        this.confirm(this.$t('keyword.confirm_save_file_x_name', {x: this.save_keyword_file.filename}), () => {
          this.save_keyword_file.loading = true

          this.$http.post(this.API.marketing.keyword_file.add, {
            filename: this.save_keyword_file.filename,
            keyword_json: keyword_list.map(i => {
              return {
                checked: true,
                keyword: i.search_keyword,
                keyword_source_type: 0,
                price: i.price || i.recommend_price,
                record_type: 0,
                rnum: 0,
                sp_price: i.price || i.recommend_price,
                sp_volume: 0,
                match_type: i.match_type
              }
            })
          }, this.cf())
            .then(async (resp) => {
              this.ntf_s(resp)
              this.save_keyword_file.loading = false
              this.save_keyword_file.show = false

              this.$emit('m__reload_saved_keyword')
            })
            .catch(error => {
              console.error(error)
              this.ntf_w(error)
              this.save_keyword_file.loading = false
            })
        })
      }

      if (this.save_keyword_file_type === 'update') {
        if (!this.selected_keyword_file) return
        try {
          await this.$confirm(this.$t('base.update_file_confirm'), this.$t('base.attention'), {
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
            type: 'warning'
          })
        } catch (e) {
          return
        }

        this.save_keyword_file.loading = true
        const current_file = this.keyword_file_list.find(i => i._id === this.selected_keyword_file)

        const detail_response = await this.$http.get(this.API.marketing.keyword_file.detail.replace('_id', this.selected_keyword_file), this.cf())
        if (detail_response.body && detail_response.body.data && detail_response.body.data.keyword_json) {
          for (const keyword of keyword_list) {
            const found = detail_response.body.data.keyword_json.find(i => i.keyword === keyword.search_keyword)
            if (!found) {
              detail_response.body.data.keyword_json.push({
                checked: true,
                keyword: keyword.search_keyword,
                keyword_source_type: 0,
                price: keyword.price || keyword.recommend_price,
                record_type: 0,
                rnum: 0,
                sp_price: keyword.price || keyword.recommend_price,
                sp_volume: keyword.report ? keyword.report.search_volume : 0,
                match_type: keyword.match_type
              })
            }
          }

          const update_response = await this.$http.put(this.API.marketing.keyword_file.update.replace('_id', this.selected_keyword_file), {
            ...current_file,
            keyword_count: detail_response.body.data.keyword_json.length,
            keyword_json: detail_response.body.data.keyword_json
          }, this.cf())
          this.ntf_s(update_response)
          this.save_keyword_file.loading = false
          this.save_keyword_file.show = false
          this.$emit('m__reload_saved_keyword')
        }

        this.save_keyword_file.loading = false
      }
    },

    m__initial_save_keyword_file() {
      if (!this.c__show_keyword_filter_list.filter(i => i.checked).length) {
        this.ntf_w(this.$t('required.select_keywords'))
        return
      }

      if (this.save_keyword_file_type === 'add') {
        this.save_keyword_file.filename = this.$t('keyword.file') + ' ' + this.c__show_keyword_filter_list.filter(i => i.checked)[0].search_keyword + ' - ' + this.dayjs().format('DD/MM/YYYY')
      }

      this.save_keyword_file.show = true
    },

    async m__confirm_add_keywords() {
      if (!this.add_keyword_list.length) {
        this.ntf_w(this.$t('required.select_keywords'))
        return
      }

      try {
        await this.$confirm(this.$t('base.add_keywords_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
      }

      this.loading.add_keywords = true
      try {
        const MAX_LIMIT = ADS_CONSTANTS.MAX_KEYWORDS_LENGTH
        if (this.parent_keyword_list.filter(i => i.status === 1).length + this.add_keyword_list.length > MAX_LIMIT) {
          this.ntf_w(this.$t('not_exceed_max', {
            x: MAX_LIMIT,
            c: this.parent_keyword_list.filter(i => i.status === 1).length + this.add_keyword_list.length
          }))
          this.loading.add_keywords = false
          return
        }

        const update_resp = await this.sp_user.marketing_pas_add_keyword(this.campaign_id, this.add_keyword_list, this.campaign_type)
        console.log('update_resp', update_resp)
        if (update_resp.code === 0) {
          this.$emit('reload_data');
          this.show_dialog.add_keywords = false
          this.$t('base.add_keyword_success')
        } else {
          if (['batch update ads keyword fail', 'inconsistent data', 'update fail'].includes(update_resp.msg)) {
            for (const keyword of this.add_keyword_list) {
              await this.sleep(500)

              const update_resp = await this.sp_user.marketing_pas_add_keyword(this.campaign_id, [keyword])
              console.log('keyword:', keyword.keyword, '- update_resp:', JSON.stringify(update_resp))
            }

            this.$emit('reload_data');
            this.show_dialog.add_keywords = false
            this.$t('base.add_keyword_success')
          } else {
            this.ntf_w(this.$t('ads.error_with_add_keywords') + '. ' + this.$t('base.error_code') + ': ' + update_resp.msg)
          }
        }
      } catch (e) {
        console.error(e)
        this.$t('base.has_an_occurred')
      } finally {
        this.loading.add_keywords = false

        for (const keyword of this.keyword_list) {
          // keyword.is_exists = this.parent_keyword_list.some(i => i.keyword.normalize() === keyword.search_keyword.normalize())
          keyword.is_exists = this.parent_keyword_list.filter(i => i.status === 1).some(i => i.keyword.normalize() === keyword.search_keyword.normalize())
        }
      }
    },

    m__delete_add_keyword(index) {
      this.add_keyword_list.splice(index, 1)
    },

    m__update_keyword_price() {
      if (this.form_update_multiple_keyword_price.update_type === 1 && this.form_update_multiple_keyword_price.update_by_cost_value) {
        this.add_keyword_list.forEach(i => {
          if (this.form_update_multiple_keyword_price.update_by_cost === 'increase') {
            i.price += this.m__calculate(this.form_update_multiple_keyword_price.update_by_cost_value)
          }

          if (this.form_update_multiple_keyword_price.update_by_cost === 'reduce') {
            i.price -= this.m__calculate(this.form_update_multiple_keyword_price.update_by_cost_value)
          }
        })
      }

      if (this.form_update_multiple_keyword_price.update_type === 2 && this.form_update_multiple_keyword_price.update_by_percent_value) {
        this.add_keyword_list.forEach(i => {
          if (this.form_update_multiple_keyword_price.update_by_percent === 'increase') {
            i.price += (i.price * this.m__calculate(this.form_update_multiple_keyword_price.update_by_percent_value) / 100)
          }

          if (this.form_update_multiple_keyword_price.update_by_percent === 'reduce') {
            i.price -= (i.price * this.m__calculate(this.form_update_multiple_keyword_price.update_by_percent_value) / 100)
          }
        })
      }

      if (this.form_update_multiple_keyword_price.update_type === 3) {
        this.add_keyword_list.forEach(i => {
          i.price = this.m__calculate(this.form_update_multiple_keyword_price.price)
        })
      }

      this.show_dialog.update_keyword_price = false
    },

    m__show_add_keywords_dialog() {
      if (!this.c__show_keyword_filter_list.filter(i => i.checked).length) {
        this.ntf_w(this.$t('required.select_keywords'))
        return
      }

      const add_keyword_list = this.c__show_keyword_filter_list.filter(i => i.checked).map(i => ({
        keyword: i.search_keyword,
        match_type: 0,
        price: i.atosa_cpc ? this.m__calculate(i.atosa_cpc) : this.m__calculate(this.ads_config.bid_price[`search_${this.campaign_type || 'product'}`].exact_match.min / 100000)
      }))
      this.add_keyword_list = _uniqBy(add_keyword_list, 'keyword')

      this.show_dialog.add_keywords = true
    },

    m__checked_by_page() {
      this.is_selected_all = false
      this.indeterminate = true
      const start_index = (this.keyword_filter.current_page - 1) * this.keyword_filter.page_size
      const end_index = start_index + this.keyword_filter.page_size - 1

      for (const [index, keyword] of this.c__show_keyword_filter_list.entries()) {
        keyword.checked = index >= start_index && index <= end_index
      }
    },

    m__use_filter(data) {
      for (const item of data.data) {
        const found = this.mix_filter.find(i => i.camel_key === item.camel_key)
        if (found) {
          found.expression = item.expression
          found.value = item.value
          found.value2 = item.value2
        }
      }
      this.show_dialog.filter_list = false
    },

    m__delete_filter() {
      this.mix_filter.forEach(i => {
        i.value = null
        i.expression = '>'
      })
      this.filter_clone = null
      this.show_dialog.filter = false
    },

    m__start_filter() {
      let any_change = false
      for (const item of this.mix_filter) {
        if (item.value) {
          any_change = true
          break
        }
      }
      if (!any_change) {
        this.filter_clone = null
      } else {
        this.filter_clone = this.clone(this.mix_filter)
      }
      this.show_dialog.filter = false
    },

    m__show_filter_dialog() {
      this.show_dialog.filter = true
    },

    m__on_select_csv_file() {
      document.getElementById('report_analysis_input').click()
    },

    async m__update_flag_list() {
    },

    async m__set_atosa_flag_list() {
      const flags = this.atosa_flag_list.filter(i => i.checked).map(i => i.value)
      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_flags/set', {
        shop_id: this.shop._id,
        flags
      }, this.cf())
    },

    m__toggle_select_index() {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      this.show_dialog.select_index = !this.show_dialog.select_index
    },

    m__is_show_index(value) {
      const flag = this.flag_list.find(i => i.value === value)
      if (flag) {
        return flag.checked
      } else {
        return false
      }
    },

    m__is_show_atosa_index(value) {
      const flag = this.atosa_flag_list.find(i => i.value === value)
      return flag ? flag.checked : false
    },

    m__select_all() {
      this.indeterminate = false
      if (this.is_selected_all) {
        this.c__show_keyword_filter_list.forEach(i => {
          i.checked = true
        })
      } else {
        this.keyword_list.forEach(i => {
          i.checked = false
        })
      }
    },

    m__indeterminate(e) {
      console.log(e)
      if (this.keyword_list.filter(i => i.checked === true).length === this.keyword_list.length) {
        this.is_selected_all = true
        this.indeterminate = false
      } else if (this.keyword_list.filter(i => i.checked === true).length === 0) {
        this.is_selected_all = false
        this.indeterminate = false
      } else {
        this.is_selected_all = false
        this.indeterminate = true
      }
    },

    m__on_checkbox_click(event, index) {
      if (event.shiftKey && this.last_single_checked) {
        const start = Math.min(this.last_single_checked, index);
        const end = Math.max(this.last_single_checked, index);

        for (let i = start; i <= end; i++) {
          this.c__show_keyword_display_list[i].checked = true
        }

        event.preventDefault()
      } else {
        this.last_single_checked = index
      }
    },

    m__style_for_summary({row}) {
      if (row.is_summary) return {'background-color': '#F5F7FA'}
    },

    m__sort_change({
                     prop,
                     order
                   }) {
      this.sort_option.order = order
      this.sort_option.prop = prop
    },


    m__report_analysis_from_file(event) {
      this.loading.get_data = true
      this.keyword_list = []

      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const content = e.target.result;
          await this.m__handle_content_file(content)
          this.loading.get_data = false
        };
        reader.readAsText(file);
      } else {
        this.loading.get_data = false
      }

      event.target.value = null
    },

    async m__report_analysis() {
      this.loading.get_data = true

      this.keyword_list = []

      const start_date = this.date_range[0]
      const end_date = this.date_range[1]
      const start_time = this.dayjs(start_date).startOf('d').unix()
      const end_time = this.dayjs(end_date).endOf('d').unix()

      const trigger_response = await this.sp_user.marketing_pas_report_trigger_or_get_previous({
        start_time,
        end_time,
        header: {},
        report_type: this.report_type,
        campaign_id: this.campaign_id
      })
      if (trigger_response && trigger_response.data && trigger_response.data.export_id) {
        const {export_id} = trigger_response.data

        let report_result = await this.sp_user.marketing_pas_report_get_single_result(export_id)
        while (report_result && report_result.data && ['waiting', 'processing'].includes(report_result.data.status)) {
          await this.sleep(2000)
          report_result = await this.sp_user.marketing_pas_report_get_single_result(export_id)
        }

        if (report_result && report_result.data && report_result.data.status === 'success') {
          const download_response = await this.sp_user.marketing_pas_report_download(export_id)
          const anchor = document.createElement('a')
          anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(download_response.data.content)
          anchor.target = '_blank'
          anchor.download = `${this.shop.username}.-${download_response.data.file_name}`
          anchor.click()

          await this.m__handle_content_file(download_response.data.content)
        } else {
          this.ntf_w(this.$t('base.cannot_export_report'))
        }
      } else {
        this.ntf_w(this.$t('base.cannot_export_report'))
      }

      this.loading.get_data = false
    },

    async m__handle_content_file(content) {
      // todo: faster
      try {
        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/report_analysis/handle_report_content', {
          content: content,
          parent_keyword_list: this.parent_keyword_list.filter(i => i.status === 1),
          campaign_type: this.campaign_type
        }, this.cf())
        this.keyword_list = response.body.data
      } catch (e) {
        console.error(e)
      }

      // todo: fast
      // const keyword_list = []
      // const content_chunk_list = _chunk(content.split('\n'), 500)
      // for (const chunk of content_chunk_list) {
      //   for (let i = 0; i < chunk.length; i++) {
      //     const row = chunk[i]
      //
      //     const regex = /^[0-9]+,/;
      //     if (!regex.test(row.toString())) continue;
      //
      //     const letter = row[row.indexOf(',') + 1];
      //     if (letter !== letter.toLowerCase() && letter === letter.toUpperCase()) continue
      //
      //     const data = row.replace(/[%"]/ig, '').split(',')
      //
      //     const keyword = {
      //       keyword: data[1],
      //       match_type: data[2] === this.$t('keyword.exact') ? 0 : 1,
      //       search_keyword: data[3],
      //       search_method: data[4],
      //       shopee_volume: 0,
      //       shopee_volume_search_keyword: 0,
      //       impression: +data[5],
      //       click: +data[6],
      //       ctr: +data[7] / 100,
      //       broad_order: +data[8],
      //       direct_order: +data[9],
      //       cr: +data[10] / 100,
      //       direct_cr: +data[11] / 100,
      //       cpc: +data[12],
      //       cpdc: +data[13],
      //       broad_order_amount: +data[14],
      //       direct_order_amount: +data[15],
      //       broad_gmv: +data[16],
      //       direct_gmv: +data[17],
      //       cost: +data[18],
      //       avg_rank: +data[19],
      //       broad_roi: +data[20],
      //       direct_roi: +data[21],
      //       broad_cir: +data[22] / 100,
      //       direct_cir: +data[23] / 100,
      //     }
      //     keyword.checked = false
      //     keyword.atosa_cpc = +keyword.click ? this.m__calculate(+keyword.cost / +keyword.click) : 0
      //     keyword.cpm = +keyword.impression ? this.m__calculate(+keyword.cost / +keyword.impression * 1000) : 0
      //     keyword.aov = keyword.broad_order !== 0 ? this.m__calculate(keyword.broad_gmv / keyword.broad_order) : 0
      //     keyword.is_exists = this.parent_keyword_list.some(i => i.keyword.normalize() === keyword.search_keyword.normalize())
      //
      //     keyword_list.push(keyword)
      //   }
      // }
      // this.keyword_list = _orderBy(this.clone(keyword_list), ['broad_gmv', 'click', 'impression'], ['desc', 'desc', 'desc'])

      // todo: slow
      // const group_keyword_list = []
      // for (let i = 0; i < keyword_list.length; i++) {
      //   const keyword = keyword_list[i]
      //   const keyword_found = group_keyword_list.find(i => i.search_keyword.normalize() === keyword.search_keyword.normalize() && i.keyword === keyword.keyword)
      //
      //   if (keyword_found) {
      //     for (const key of Object.keys(keyword)) {
      //       if (['keyword', 'match_type', 'search_keyword', 'search_method', 'shopee_volume', 'shopee_volume_search_keyword'].includes(key)) continue
      //
      //       keyword_found[key] += keyword[key]
      //     }
      //   } else {
      //     for (const key of Object.keys(keyword)) {
      //       if (['keyword', 'match_type', 'search_keyword', 'search_method', 'shopee_volume', 'shopee_volume_search_keyword'].includes(key)) continue
      //
      //       if (!keyword[key]) keyword[key] = 0
      //     }
      //     group_keyword_list.push(keyword)
      //   }
      // }
      // for (let i = 0; i < group_keyword_list.length; i++) {
      //   const keyword = group_keyword_list[i]
      //   keyword.checked = false
      //
      //   if (keyword.atosa_cpc) {
      //     keyword.atosa_cpc = keyword.click
      //       ? this.m__calculate(keyword.cost / keyword.click)
      //       : 0
      //   }
      //   if (keyword.cpm) {
      //     keyword.cpm = keyword.impression
      //       ? this.m__calculate(keyword.cost / keyword.impression * 1000)
      //       : 0
      //   }
      //   if (keyword.aov) {
      //     keyword.aov = keyword.broad_order
      //       ? this.m__calculate(keyword.broad_gmv / keyword.broad_order)
      //       : 0
      //   }
      //   if (keyword.ctr) {
      //     keyword.ctr = keyword.impression
      //       ? keyword.click / keyword.impression
      //       : 0
      //   }
      //   if (keyword.broad_cir) {
      //     keyword.broad_cir = keyword.broad_gmv
      //       ? keyword.cost / keyword.broad_gmv
      //       : 0
      //   }
      //   if (keyword.direct_cir) {
      //     keyword.direct_cir = keyword.direct_gmv
      //       ? keyword.cost / keyword.direct_gmv
      //       : 0
      //   }
      //   if (keyword.broad_roi) {
      //     keyword.broad_roi = keyword.cost
      //       ? keyword.broad_gmv / keyword.cost
      //       : 0
      //   }
      //   if (keyword.direct_roi) {
      //     keyword.direct_roi = keyword.cost
      //       ? keyword.direct_gmv / keyword.cost
      //       : 0
      //   }
      //   if (keyword.cr) {
      //     keyword.cr = keyword.click
      //       ? keyword.broad_order / keyword.click
      //       : 0
      //   }
      //   if (keyword.direct_cr) {
      //     keyword.direct_cr = keyword.click
      //       ? keyword.direct_order / keyword.click
      //       : 0
      //   }
      //   if (keyword.cpc) {
      //     keyword.cpc = keyword.broad_order
      //       ? keyword.cost / keyword.broad_order
      //       : 0
      //   }
      //   if (keyword.cpdc) {
      //     keyword.cpdc = keyword.broad_order
      //       ? keyword.cost / keyword.direct_order
      //       : 0
      //   }
      //   if (keyword.cpm) {
      //     keyword.cpm = keyword.impression
      //       ? this.m__calculate(keyword.cost / keyword.impression * 1000)
      //       : 0
      //   }
      //   if (keyword.cpa) {
      //     const impression = keyword.impression ? keyword.impression : 0
      //     const ctr = keyword.ctr ? keyword.ctr : 0
      //     const cr = keyword.cr ? keyword.cr : 0
      //     const action = impression * ctr * cr
      //     keyword.cpa = action ? this.m__calculate(keyword.cost / action) : 0
      //   }
      //
      //   keyword.is_exists = this.parent_keyword_list.some(i => i.keyword.normalize() === keyword.search_keyword.normalize())
      // }
      // this.keyword_list = this.clone(group_keyword_list)
      // this.keyword_list = _orderBy(this.keyword_list, ['broad_gmv', 'click', 'impression'], ['desc', 'desc', 'desc'])

      // todo: get shopee volume
      if (this.keyword_list.length) {
        this.$http.post(this.API.URL_API_SRV_2 + '/keyword/save_and_result', {
          mipeeUserId: this.$store.state.userInfo.username,
          keyword: this.keyword_list[0].keyword,
          data: [...this.keyword_list.map(i => i.keyword), ...this.keyword_list.map(i => i.search_keyword)]
        }, this.cf())
          .then(async (resp) => {
            const save_and_result_list = resp.body
            for (const item of this.keyword_list) {
              const found = save_and_result_list.find(i => i.keyword === item.keyword)
              if (found) {
                item.shopee_volume = found.volume
              }

              const search_found = save_and_result_list.find(i => i.keyword === item.search_keyword)
              if (search_found) {
                item.shopee_volume_search_keyword = search_found.volume
              }
            }
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/pas/component/component_report_analysis.vue